module.exports = __webpack_public_path__ + "static/media/Portrait-10194.1c47ef38.jpg";